import { render, staticRenderFns } from "./LibraryShare.vue?vue&type=template&id=56a9182b&scoped=true&lang=pug&"
import script from "./LibraryShare.vue?vue&type=script&lang=js&"
export * from "./LibraryShare.vue?vue&type=script&lang=js&"
import style0 from "./LibraryShare.vue?vue&type=style&index=0&id=56a9182b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9182b",
  null
  
)

export default component.exports